var enable_logging = true;
var enable_alert_logging = true;
// Our application's global object
var app = {};

app.initialize = function() {
    log('initialize');
    // Listen to the deviceready event.
    // Make sure the score of 'this' isn't lost.
    document.addEventListener('deviceready', this.bind(this.onDeviceReady), false);
};

//
// Methods
// -------
//


// deviceready event handler.
//

// Avvia l'intervallo per eseguire la funzione ogni 100 millisecondi
var checkInterval;
var ref;
var playerSource;
var db;

var pusher = new Pusher('1951c674aef8e8b86430', {
    wsHost: 'socket.teyuto.tv',
    wsPort: 6001,
    forceTLS: false,
    encrypted: true,
    disableStats: true,
    enabledTransports: ['ws', 'wss'],
});

function intentHandler(url) {
//    alert(url);
}

// Start logging
app.onDeviceReady = function() {

    try {
        //ios exc
        cordova.plugins.windowVisibility.setDelay(0,
            function(success) { console.log('Delay set:', success); },
            function(error) { console.error('Error setting delay:', error); }
        );
    } catch (e) {
        console.log(e);
    }

    // Tasto/gesture indietro Android: passa da Nav (stesso percorso di X,
    // swipe-down e bottoni). Se siamo alla radice, chiude l'app.
    try {
        window.Capacitor.Plugins.App.addListener('backButton', function() {
            if (!Nav.back()) {
                window.Capacitor.Plugins.App.exitApp();
            }
        });
    } catch (e) {
        console.log(e);
    }

    try {
        // scrollbar nativo nascosto anche qui a runtime (ridondante col fix
        // diretto in MainViewController.swift, ma copre eventuali WKWebView
        // create da altri plugin dopo il primo layout)
        cordova.plugins.hideScrollbars.hide(
            function() {
                console.log('Scrollbars hidden successfully');
            },
            function(error) {
                console.error('Error: ' + error);
            }
        );
    } catch (e) {
        console.log(e);
    }
    
    try {
        db = window.sqlitePlugin.openDatabase({
            name: 'teyuto.db',
            location: 'default'
        });
    } catch (e) {
        console.log(e);
    }

    //app updates
    try {
        // window.plugins.updatePlugin.update(()=>{
        // //success callback
        // },()=>{
        // //error callback
        // },{
        // IOS: {
        //         type: "MIXED",
        //         flexibleUpdateStalenessDays: 2,
        //         immediateUpdateStalenessDays: 5
        // },
        // ANDROID: {
        //         type: "MIXED",
        //         flexibleUpdateStalenessDays: 2,
        //         immediateUpdateStalenessDays: 5
        //     }
        // });
    } catch (e) {
        console.log(e);
    }
    //end in app updates

    //custom scheme url
    window.handleOpenURL = function(url) {
        if (url.indexOf('://') === -1) url = decodeURIComponent(url);
        // Esegui il parsing dell'URL
        var urlParams = new URLSearchParams(url.split('?')[1]);
        var token = urlParams.get('token'); // Estrai il token
        // iOS: la SFSafariViewController resta aperta sopra l'app anche
        // quando lo schema riporta in primo piano l'app stessa
        try { cordova.plugins.browsertabs.close(); } catch (e) {}
        if (token) {
            ensureAfterLogin(token);
        } else {
            console.log("Nessun token trovato nell'URL.");
        }
    };

    // iOS: Capacitor non inoltra gli URL dello schema a window.handleOpenURL
    // (su Android lo fa il plugin customurlscheme): li riceve il plugin App
    try {
        if (isIOSNativeApp()) {
            window.Capacitor.Plugins.App.addListener('appUrlOpen', function (event) {
                if (event && event.url) { window.handleOpenURL(event.url); }
            });
        }
    } catch (e) {
        console.log(e);
    }

    // Start logging
    // LogRemoteExport.start('https://hook.eu1.make.com/n579bvp47xhaiqf1yjtv5mo0hm98ox8y', 1, '', 
    //     function(successMessage) {
    //         console.log(successMessage);
    //     },
    //     function(errorMessage) {
    //         console.error(errorMessage);
    //     }
    // );

    log('onDeviceReady');
    // alert("WAIT"); //debug for offline mode
    // Leggo le variabili globali dell'app

    // debugListFileInDirectory(45024);
    // debugListFileInDirectory(45630);
    // navigator.splashscreen.hide();

    userDeviceLanguage = navigator.language || navigator.userLanguage || "en-GB";

    // Capacitor: i dati del manifest locale dell'app arrivano dal loader via
    // query string (channel dinamico, file statici condivisi sul server).
    var _qsManifest = new URLSearchParams(window.location.search);
    $.getJSON('manifest.json', function(data) {
        if(_qsManifest.get('channel_id')) data.channel_id = _qsManifest.get('channel_id');
        if(_qsManifest.get('app_version')) data.app_version = _qsManifest.get('app_version');
        if(_qsManifest.get('apple_store_id')) data.apple_store_id = _qsManifest.get('apple_store_id');
        if(_qsManifest.get('play_store_id')) data.play_store_id = _qsManifest.get('play_store_id');
        // Web (shell PHP): il canale è quello del dominio, iniettato
        // server-side come CHANNEL_HEADER (x_channel_token). Vince su tutto.
        if (window.TY_WEB && window.CHANNEL_HEADER) data.channel_id = window.CHANNEL_HEADER;
        if(data.channel_id){
            CHANNEL_ID = data.channel_id;
        }else{
           //riprendere qui
           db.transaction(function(tx) {
                tx.executeSql('SELECT value FROM info WHERE key = ?', ['channel_id'], function(tx, result) {
                    if (result.rows.length > 0) {
                        // console.log("CHANNEL_ID recuperato:", CHANNEL_ID);
                        //commentare per debug questi sotto
                        CHANNEL_ID = result.rows.item(0).value;
                        fetchCompanyDataFromAPI(); 

                    } else {
                        // console.log("Nessun valore trovato per 'channel_id'");
                        // // Puoi impostare un valore di default o gestire la mancanza del valore
                        // CHANNEL_ID = 'valore_di_default'; // Esempio di valore di default
                        //inizio il processo per accesso flessibile canali
                        showChannelIdSelector();
                        navigator.splashscreen.hide();
                        return false;
                    }
                }, function(error) {
                    console.error("Errore durante il recupero del channel id", error);
                });
            });
        }

        APPLE_STORE_ID = data.apple_store_id;
        PLAY_STORE_ID = data.play_store_id;
        APP_VERSION = data.app_version;
        
        if (window.Connection) {
            var networkState = navigator.connection.type;
            if (networkState === Connection.NONE) {
                console.log("Il dispositivo è offline");
                ONLINE_STATUS = false;
            } else {
                // Il dispositivo è online
                ONLINE_STATUS = true;
                console.log("Il dispositivo è online");
            }
        }

        //debug
        // ONLINE_STATUS = false;

        if(ONLINE_STATUS == false){
            //fix
            $('.navbar-mobile-native').remove();

            Nav.replaceTop('download');
            listDownloaded();
            navigator.splashscreen.hide();
            return false;
        }
    
        if(CHANNEL_ID){
            fetchCompanyDataFromAPI();       
        }

    }).fail(function(jqXHR, textStatus, errorThrown) {
        console.error('Errore durante il caricamento del file JSON:', textStatus, errorThrown);
    });

    //utile se si vuole disabilitare analytics per qualcuno
    // cordova.plugins.firebase.analytics.setEnabled(false);
    // cordova.plugins.firebase.crashlytics.setEnabled(false);

    // debugListFileInDirectory(45514);
    // typeof-guard: su web (browser, senza bridge) cordova non esiste e un
    // ReferenceError qui abortirebbe in silenzio tutto il resto del boot
    if (typeof cordova !== 'undefined' && cordova.platformId == 'android') {
        try {
            StatusBar.overlaysWebView(false);
        }catch(err){
        }
    }

    try {
        cordova.plugins.firebase.messaging.requestPermission({forceShow: false}).then(function() {
            console.log("Push messaging is allowed");
        });
    } catch (e) {
        console.log(e);
    }
    
    // Esegui le query di inizializzazione del database
    db.transaction(function(tx) {
        tx.executeSql('CREATE TABLE IF NOT EXISTS download (id INTEGER PRIMARY KEY, title TEXT, collection_title TEXT, img TEXT, quality TEXT, progress INTEGER, download_date DATETIME, download_attempts INTEGER, deadline INTEGER)');
        tx.executeSql('CREATE TABLE IF NOT EXISTS info (key TEXT PRIMARY KEY, value LONGTEXT)');
    }, function(error) {
        console.error('Errore durante la creazione della tabella: ' + JSON.stringify(error));
    });
    
    
    refreshListDownloadedIds();

    ///////////////////

    // su web il plugin device non c'è: null, come la webapp (header x-teyuto-device)
    userDevice = (typeof device !== 'undefined' && device.platform) ? device.platform.toLowerCase() : null;

    // cordova.plugins.notification.local.hasPermission(function(granted) {
    //     // Questa funzione viene eseguita dopo aver controllato se il permesso è stato concesso o meno
    //     if (granted) {
    //         // L'utente ha già concesso il permesso per le notifiche locali
    //         console.log("Permission already granted for local notifications");
    //     } else {
    //         // L'utente non ha ancora concesso il permesso per le notifiche locali
    //         console.log("Permission not granted for local notifications");
    //     }
    // });

    // cordova.plugins.notification.local.requestPermission(function(granted) {
    //     // Questa funzione viene eseguita dopo che l'utente ha concesso o negato il permesso
    //     if (granted) {
    //         // L'utente ha concesso il permesso per le notifiche locali
    //         console.log("Permission granted for local notifications");
    //     } else {
    //         // L'utente ha negato il permesso per le notifiche locali
    //         console.log("Permission denied for local notifications");
    //     }
    // });

     //check company if exist
    
    // Funzione per effettuare la chiamata AJAX e salvare i dati in SecureStorage
    // lock può fallire su browser desktop: zittire sia il throw sincrono che la promise
    try {
        var _lockP = screen.orientation.lock('portrait');
        if (_lockP && typeof _lockP.catch === 'function') _lockP.catch(function () {});
    } catch (e) {}
    // log(localStorage.getItem('videoDownloadedData'));

    document.addEventListener('offline', function(event) {
        try { window.plugins.toast.showShortBottom('Connection lost'); } catch (e) {}
    }, false);
    document.addEventListener('online', function(event) {
        try { window.plugins.toast.showShortBottom('Connection recovered'); } catch (e) {}
    }, false);
    //


    checkExpiredDownload();
    checkIncompletedDownload();
    try {
        initializeCast(); // su browser chrome.cast non esiste
    } catch (e) {
        console.log(e);
    }

};

// 
// Utilities
// ---------
//

function fetchCompanyDataFromAPI() {
        
    // lingua nell'URL: fa parte della CHIAVE di cache (jalc usa l'url) —
    // senza, una risposta cachata in un'altra lingua resterebbe valida 12h
    // (header/footer in inglese); per i loggati il backend usa comunque la
    // lingua del profilo
    var langKey = '';
    try {
        langKey = normalizeChannelLanguage((typeof currentLang !== 'undefined' && currentLang) ? currentLang : (userDeviceLanguage || ''));
    } catch (e) {}

    // Effettua la chiamata AJAX
    $.ajax({
        localCache: true,
        cacheTTL: 12,
        url: URL_API+"/user/?f=settings_company&cid="+CHANNEL_ID + (langKey ? "&l=" + langKey : ""),
        method: "GET",
        dataType: "json",
        success: function(response) {
            // Gestisci la risposta ottenuta
            console.log(JSON.stringify(response));
            
            // Salva i dati ottenuti in SecureStorage
            //per ora usiamo il local storage della cache normale
            // db.transaction(function(tx) {
            //     tx.executeSql('INSERT OR REPLACE INTO info (key, value) VALUES (?, ?)', ['company', JSON.stringify(response)], function(tx, result) {
            //         console.log("Dati salvati con successo nella tabella info del database.");
            //     }, function(error) {
            //         console.error("Errore durante il salvataggio dei dati nella tabella info:", error);
            //     });
            // });

            // console.log("RESPONSEEEEEEEEEEEEEEEEEEEEE");
            // log(response);
            processCompanyData(response);
        
        },
        error: function(xhr, status, error) {
            console.error("Errore durante la chiamata AJAX:", error);
            localStorage.clear();
        }
    });
            

        // if (window.Connection) {
        //     var networkState = navigator.connection.type;
        //     if (networkState === Connection.NONE) {
        //         console.log("Il dispositivo è offline");
        //         ONLINE_STATUS = false;
                
        //         $('.mobile-list-page').hide();
        //         $('.pageMob-download').show();
        //         navigator.splashscreen.hide();

        //     } else {
        //         // Il dispositivo è online
        //         ONLINE_STATUS = true;
        //         console.log("Il dispositivo è online");
        //     }
        // }
}

function processCompanyData(data) {
    console.log("DATI DA SETTINGS COMPANY");
    console.log(JSON.stringify(data));

    companySettings = data;
    companyActiveLanding = (typeof data.active_landing !== 'undefined') ? data.active_landing : 'standard';
    companyId = data.id_channel;
    companyLogo = data.logo;
    companyName = data.name;
    companyDomain = "https://"+data.domain;
    companyIsFullScreenVideo = data.video_fullscreen; //!todo è presnete anche is_fullscreen_video
    companyVideoChat = data.video_chat; 
    companyVideoComment = data.video_comment; 
    companyRelatedVideo = data.show_related_video;
    companyShowVideoView = data.show_video_views;
    companyShowVideoViewThumb = data.show_video_views_thumb;
    // companyShowVideoViewThumb=true;
    companyShowLikeVideo = data.show_like_videos;
    companyThumbShowTitle = data.thumb_show_title;
    companySupportEmail = data.email_support;
    companyLanguages = data.enabled_languages;
    companyBackgroundColor = data.skin.backgroundColor;
    companySchemaColor = data.skin.schema;
    companyPrimaryColor = data.skin.primaryColor;
    companyDocPrivacy = data.docs_channel.privacy_policy;
    companyDocTos = data.docs_channel.terms;
    companyLoginSkippable = data.skip_login;
    companyDownloadDeadline = data.download_deadline;
    companyCustomHomePages = data.list_custom_page;
    companyAuth0Enabled = data.auth0_enabled;

    // Light skin rimossa: l'app mobile usa sempre il tema scuro/liquid glass,
    // indipendentemente da skin.schema della company.

    var primaryColorIsLight = isColorLight(companyPrimaryColor);
    companyTextColor = primaryColorIsLight == true ? '#000000' : '#ffffff';
    companyThemeDark =  primaryColorIsLight == true ? false : true;

    // Testo dei bottoni secondari col colore company (stile iOS "tinted"),
    // ma solo se contrasta col fondo; altrimenti bianco/nero neutri
    var backgroundIsLight = isColorLight(companyBackgroundColor);
    var secondaryTextColor = (primaryColorIsLight !== backgroundIsLight)
        ? companyPrimaryColor
        : (backgroundIsLight ? '#000000' : '#ffffff');

    var cssRules = `
        body {
            background: ${companyBackgroundColor} !important;
        }
        .button-primary{
            background: ${companyPrimaryColor} !important;
            color: ${companyTextColor} !important;
        }
        .button-secondary, .button-round{
            color: ${secondaryTextColor} !important;
        }
        .checkbox.style-e input:checked ~ .checkbox__checkmark {
            background-color: ${companyPrimaryColor} !important;
        }

        .checkbox.style-e:hover input:checked ~ .checkbox__checkmark {
            background-color: ${companyPrimaryColor} !important;
        }
        .notch-element-cover{
            background: ${companyBackgroundColor} !important;
        }
    `;
    var styleElement = $('<style>' + cssRules + '</style>');
    $('body').append(styleElement);
    //fine impostazioni di tema

    // tema applicato: il velo di precarico (index.html) può sparire appena
    // anche i font delle icone sono pronti (evita le icone quadrate)
    try {
        if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
            document.fonts.ready.then(function(){ window.hideAppPreloadCover && window.hideAppPreloadCover(); });
        } else {
            window.hideAppPreloadCover && window.hideAppPreloadCover();
        }
    } catch (err) {
        window.hideAppPreloadCover && window.hideAppPreloadCover();
    }

    loadChannelHeaderFooter();

    try {
        StatusBar.backgroundColorByHexString(companyBackgroundColor);
    }catch(err){
    }
    // alert(companyBackgroundColor);

    // console.log("LANGAUGESSSSSSSSSSSSSSSSSSSSS");
    // log(companyLanguages);
    // alert(data.email_support);
    // console.log(data);
    // alert(data.logo);

    $('.logo-company').attr('src', data.logo);

    // $('.navbar-mobile-native .menu').css('background', companyBackgroundColor);
    
    //check user token exists
    try {
        db.transaction(function(tx) {
            tx.executeSql('SELECT COUNT(*) AS count, value FROM info WHERE key = ?', ['token'], function(tx, result) {
                var count = result.rows.item(0).count;
                if(count > 0){
                    userToken = result.rows.item(0).value;
                }

                updateUserInfo();

            }, function(error) {
                console.error('Errore durante la verifica dell\'esistenza del valore nella tabella info:', error);
                updateUserInfo();
            });
        });
    } catch (e) {
        console.log(e);
        updateUserInfo();
    }

}

function tyIsNativeRuntime() {
    try {
        if (typeof isNativeApp === 'function') {
            return !!isNativeApp();
        }
        return !!(window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform());
    } catch (err) {
        return false;
    }
}

function tyResolveActiveLandingMode() {
    var mode = (typeof companyActiveLanding !== 'undefined') ? companyActiveLanding : 'standard';
    if (mode === 'catalog' || mode === -1 || mode === '-1') {
        return 'catalog';
    }
    if (mode === false || mode === 0 || mode === '0' || mode === 'false') {
        return 'disabled';
    }
    return 'standard';
}

// Regola unica per la home:
// - nativo iOS/Android: sempre catalogo (user) anche da guest
// - web: semantica active_landing (standard/catalog/disabled)
function tyResolveHomePageTarget(type, idCustom) {
    var requestedType = (typeof type === 'undefined' || type === null) ? 1 : type;
    var requestedIdCustom = (typeof idCustom === 'undefined' || idCustom === null) ? 'user' : idCustom;
    var isLogged = !!(userData && userData.status === 'success');
    var wantsUserHome = (requestedType === 1 || requestedType === '1' || requestedIdCustom === 'user');

    if (isLogged || !wantsUserHome) {
        return {
            type: requestedType,
            idCustom: requestedIdCustom,
            shouldPromptLogin: false
        };
    }

    if (tyIsNativeRuntime()) {
        return {
            type: 1,
            idCustom: 'user',
            shouldPromptLogin: false
        };
    }

    var mode = tyResolveActiveLandingMode();
    if (mode === 'catalog') {
        return {
            type: 1,
            idCustom: 'user',
            shouldPromptLogin: false
        };
    }
    if (mode === 'disabled') {
        return {
            type: 1,
            idCustom: 'user',
            shouldPromptLogin: true
        };
    }
    return {
        type: 0,
        idCustom: 'guest',
        shouldPromptLogin: false
    };
}

function generateAndHandleNewToken(type='login') {
    // Genera un nuovo token e gestisci il login se nessun token è stato trovato
    var tokenRandomGenerated = [...Array(40)].map(() => Math.random().toString(36)[2]).join('');
    var loginUrl = companyDomain+'/'+type+'?app=1&l='+currentLang+'&auth_token=' + tokenRandomGenerated;
    var appScheme = new URLSearchParams(window.location.search).get('app_scheme') || PLAY_STORE_ID;
    if (appScheme) loginUrl += '&app_scheme=' + encodeURIComponent(appScheme);
    
    // var inappbrowserLocation='yes';
    // if(companyAuth0Enabled){
    //     inappbrowserLocation='yes';
    // }
    // var options = `location=${inappbrowserLocation},fullscreen=yes,toolbarcolor=${companyBackgroundColor},hideurlbar=yes,navigationbuttoncolor=${companyBackgroundColor},closebuttoncolor=${companyTextColor},hardwareback=yes`;

    // return false;
    // var refLogin = cordova.InAppBrowser.open(loginUrl, "_blank", options);
    // refLogin.addEventListener('loadstart', function(event) {
    //     if (event.url.includes("closeinapp=1")) {
    //         refLogin.close();
    //     }
    // });

    // Pusher.logToConsole = true; // Abilita i log per il debugging

    // pusher.connection.bind('error', function(err) {
    //     console.error("Errore Pusher:", JSON.stringify(err));
    // });

    var channel = pusher.subscribe('app-auth-'+tokenRandomGenerated);
    
    channel.bind('login', function(data) {
        cordova.plugins.browsertabs.close();
        if(data.token) {
            ensureAfterLogin(data.token);
        }
    });

    // iOS: window.handleOpenURL non viene mai chiamato (customurlscheme su
    // iOS si appoggia a CDVHandleOpenURL, che Capacitor non include) e con la
    // SFSafariViewController aperta il JS della WebView può restare sospeso.
    // Con 'scheme' il plugin intercetta da nativo il ritorno <schema>://,
    // chiude la tab e restituisce l'URL nel callback di successo.
    var tabOptions = { authSession: false };
    if (appScheme && isIOSNativeApp()) { tabOptions.scheme = appScheme; }

    cordova.plugins.browsertabs.openUrl(loginUrl, tabOptions, function (url) {
        if (typeof url === 'string' && url.indexOf('://') !== -1) {
            window.handleOpenURL(url);
            return;
        }
        onSuccessBrowserTabOpened();
    }, onErrorBrowserTabOpened);
    

    setFirebaseAnalyticsPage("login");
}

var tyLoginTokenInFlight = null;
function ensureAfterLogin(token){
    // lo stesso token può arrivare da Pusher, dallo schema (plugin browsertabs)
    // e da appUrlOpen: salvato e applicato una volta sola
    if (!token || token === userToken || token === tyLoginTokenInFlight) { return; }
    tyLoginTokenInFlight = token;
    // tick separato: questa funzione può arrivare da un callback Pusher e il
    // plugin SQLite documenta instabilità se usato nello stesso tick di pusher-js
    setTimeout(function() {
        db.transaction(function(tx) {
            tx.executeSql('INSERT OR REPLACE INTO info (key, value) VALUES (?, ?)', ['token', token]);
        }, function(error) {
            console.error('Errore durante il salvataggio del token nella tabella info:', error);
            tyLoginTokenInFlight = null;
        }, function() {
            // callback di successo della TRANSAZIONE (commit avvenuto), non del
            // singolo statement: navigare/ricaricare prima del commit può far
            // perdere la scrittura (issue nota del plugin dopo location change)
            console.log("Token salvato con successo nella tabella info.");
            userToken = token;
            localStorage.clear();
            updateUserInfo();
            checkGeneralCurrentState();
        });
    }, 0);
}

function startPayInApp(productId){
    // alert(productId);
    // productId='subs_1408'; //debug
    inAppPurchases.purchase(productId).then( function(purchase){
        if (purchase["pending"]){
            // alert("waiting for payment to complete");
            return; //not paid for yet
        }
        // handle purchase here, or after its been completed:
        //prodotto acquistato

        //invio il pagamento al server
        // if(userDevice == 'ios'){
        //     //do nothing
        // }else if(userDevice == 'android'){
        //     //do nothing
        // }else{
        //     window.plugins.toast.showShortBottom(translate('ERROR_OCCURRED'));
        //     return false;
        // }

        var dataString = 
            "productId=" + purchase['productId'] 
            + "&purchaseTime=" + purchase['purchaseTime']
            + "&purchaseId=" + purchase['purchaseId']
            + "&purchaseToken=" + purchase['purchaseToken']
            + "&quantity=" + purchase['quantity']
            + "&verified=" + purchase['verified']
            + "&receipt=" + purchase['receipt']
            + "&pending=" + purchase['pending']
            + "&completed=" + purchase['completed']
            + "&device=" + userDevice;
        $.ajax({
            type: "POST",
            url: URL_API2 + '/payments/app',
            data: dataString,
            cache: false,
            success: function (c) {
                checkGeneralCurrentState();
                localStorage.clear();
                window.plugins.toast.showShortBottom(translate('PURCHASED_CORRECTLY'));
                return inAppPurchases.completePurchase(purchase["productId"]);
            },
            error: function(){
                window.plugins.toast.showShortBottom(translate('ERROR_OCCURRED'));
            }
        });

        //fine invio 
    }).then(function(purchase){
        checkGeneralCurrentState();
        localStorage.clear();
        // purchase is acknowledged and consumed
    }).catch (function(err){
        logError(err);
    });
}


function startDownloadContentBatch(videoIds, quality=null, batch=false){
    
    videoIds = videoIds.split(",");

    if(videoIds.length > 0){

        if(userData.status != 'success'){
            openModalLogin();
            return false;
        }

        if(batch == true){
        //   $('.downloadedVideoMultiple').html(`
        //       <i class="ri-check-line font-size-16"></i>
        //   `); 
        }

        if(userData.download_quality == 'ask' && quality == null){
            createModalBoxStreamsAndDownloadQuality(videoIds);
            //faccio return false per non continuare il download
            return false;
        }else if(userData.download_quality == 'ask' && quality){
            //vuol dire che la qualità è stata selezionata nell'azione precente di return
            // do nothing
        }else{
            quality = userData.download_quality;
        }

       
        for(i=0; i < videoIds.length; i++){
            $('.downloadedVideo-'+videoIds[i]).html(`<i class="ri-download-fill font-size-16"></i> 0%`);

            //faccio la chiamata per ottenere le info del video
            $.ajax({
                type: 'GET',
                url: URL_API2 + '/videos/' + videoIds[i],
                success: function (json) {
                    let obj = JSON.parse(json);
                    if (Array.isArray(obj)) {
                        obj = obj[0];
                    }
                    // console.log(obj.id);
                    // alert(obj.img_preview);
                    startDownloadContent(obj.id, obj.title, obj.collection_title, obj.img_preview, quality);
                }
            });
        } 
    }
}

function startDownloadContent(id, title=null, collection_title=null, img=null, quality=null){ 
    
    if(!id){
        console.log("OGGETTO VIDEO PER IL DOWNLOAD NON TROVATO");
        return false;
    }

    // Registro subito il contenuto in download usando l'immagine remota disponibile,
    // così la thumbnail è immediata lato UI mentre parte il download.
    addVideoData(id, title, collection_title, img ? img : null, quality);

    if (!img) {
        console.log("URL dell'immagine non fornito");
        return;
    }

    // In parallelo scarico la preview locale (video/<id>/preview.jpg): serve
    // alla pagina offline. Il campo img nel db resta l'URL REMOTO — non va
    // sovrascritto col path locale, che dall'origin remoto (app Capacitor)
    // non è visualizzabile e romperebbe le thumbnail della lista download.
    var filePath = cordova.file.dataDirectory + "video/" + id + "/preview.jpg";
    downloadAndSaveFile(img, filePath, id)
        .then(function() {
            console.log("Preview locale salvata:", filePath);
        })
        .catch(function(error) {
            console.error("Errore durante il download della preview locale:", error);
        });
}


// shortcut to the app logging function.
function log(arg) { app.log(arg); }

// log both in the console and in the HTML #log element.
app.log = function(arg) {
    try {
        if (typeof arg !== 'string')
            arg = JSON.stringify(arg);
        console.log(arg);
        // document.getElementById('log').innerHTML += '<div>' + arg + '</div>';
    } catch (e) {}
};

// make sure fn will be called with app as 'this'
app.bind = function(fn) {
    return function() {
        fn.call(app, arguments);
    };
};

function setRemoteFcmToken(fcmToken, device, teyutoToken){
    var xhr = new XMLHttpRequest();
    var url = URL_API+'/user?f=set_device_token_v2';
    var params = 'auth_token='+teyutoToken+'&device_token='+fcmToken+'&device='+device;
    xhr.open('POST', url, true);
    xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    xhr.onreadystatechange = function() {
        if (xhr.readyState == 4 && xhr.status == 200) {
            console.log(xhr.responseText);
        }
    };
    xhr.send(params);
}

function setFirebaseAnalyticsPage(page){
    try {
        cordova.plugins.firebase.analytics.setCurrentScreen(page);
    } catch (error) {
        // console.error(error);
    }
}

function setFirebaseAnalyticsEvent(obj){
    try {
        cordova.plugins.firebase.analytics.logEvent(obj);
    } catch (error) {
        // console.error(error); // su web cordova non esiste: silenzioso
    }
}

function refreshListDownloadedIds(){
    listDownloadedVideosIds = [];
    db.transaction(function(tx) {
        tx.executeSql('SELECT id FROM download', [], function(tx, result) {
            for (var i = 0; i < result.rows.length; i++) {
                var id = result.rows.item(i).id;
                listDownloadedVideosIds.push(id);
            }
            console.log("ID dei video scaricati:", listDownloadedVideosIds);
        }, function(error) {
            console.error("Errore durante il recupero degli ID dei video scaricati:", error);
        });
    });
}

function isColorLight(hexColor) {
    try{
        hexColor = hexColor.replace("#", "");
        var r = parseInt(hexColor.substr(0, 2), 16);
        var g = parseInt(hexColor.substr(2, 2), 16);
        var b = parseInt(hexColor.substr(4, 2), 16);
        var brightness = (r * 299 + g * 587 + b * 114) / 1000;
        return brightness > 155;
    }catch(err){
        return true;
    }
}



// render della home all'arrivo dei dati utente: se è già aperta una pagina
// custom (deep-link web /page?id_custom=…) va ricaricata quella, non la home.
// Solo web: sulle app native resta il comportamento storico (sempre home)
function tyLoadActiveHomePage(homeTarget) {
    if (window.TY_WEB && currentCustomPageActive &&currentCustomPageActive !== 'user' && currentCustomPageActive !== 'guest') {
        loadHomepageSections('page', CHANNEL_ID, 0, null, null, currentCustomPageActive);
    } else {
        loadHomepageSections(homeTarget.type, CHANNEL_ID, 0, null, null, homeTarget.idCustom);
    }
}

function updateUserInfo() {

    // alert(token);
    function handleUserData(data) {
        userData = data;
        LANGUAGE_LINES = data.language;
        currentLang = data.language['info'].code; //!todo
        // alert(currentLang);
        configureNativeLanguages();

        $('#header-user-img-profile').attr('src', data.profile_image);

        var homeTarget = tyResolveHomePageTarget(1, 'user');
        tyLoadActiveHomePage(homeTarget);

        generateProfileSection();

        generateCustomHomePages();
        
        //chiudo lo splash screen
        // try{
            navigator.splashscreen.hide();
        // }catch(err){}

        if (data.status == 'success') {

            //non spostare questo da qui
            initPusherToPreventMultiSession();

            if (data.email_verified == false) {
                showEmailToVerify(); //!todo
            }

            //firebase analytics set
            try {
                cordova.plugins.firebase.crashlytics.setUserId(data.id_user);
                cordova.plugins.firebase.analytics.setUserId(data.id_user);
                cordova.plugins.firebase.analytics.setUserProperty("email", data.email);
                cordova.plugins.firebase.analytics.setUserProperty("language", currentLang);
            } catch (error) {
                console.error(error);
            }
            //..
            ///

            //FIREBASE
            console.log("----------FIREBASE-----------");
            try {
                cordova.plugins.firebase.messaging.getToken().then(function(fcmToken) {
                    console.log("Got device token: "+ fcmToken);
                    // setRemoteFcmToken(fcmToken, userDevice, userToken);
                });
            } catch (e) {
                // web: cordova assente — il resto di handleUserData deve proseguire
            }
            


        } else {
            if (window.TY_WEB && homeTarget.shouldPromptLogin) {
                openModalLogin(true);
            }
        }
    }
    $.ajax({
        type: 'GET',
        url: URL_API + '/user/?f=user_data',
        dataType: 'json',
        // headers: headers,
        success: function (data) {
            console.log(data);
            handleUserData(data);
            // loadPageVideo(45851);
        },
        error: function (data){
            console.log(JSON.stringify(data));
            var homeTarget = tyResolveHomePageTarget(1, 'user');
            tyLoadActiveHomePage(homeTarget);
            navigator.splashscreen.hide();
            if (window.TY_WEB && homeTarget.shouldPromptLogin) {
                openModalLogin(true);
            }
        }
    });
}

function reloadAppNow(){
    navigator.splashscreen.show();
    
    localStorage.clear();
    window.plugins.toast.showShortBottom('Updating');

    window.location.reload(true);
}

function showEmailToVerify(){
    $('body').append(`
        <div id="modal-verify-email" class="modal fade">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-body" id="modal-verify-email-body" >
                         <div class="text-center pa-2" style="margin-top:30vh;">
                            <img src="${companyLogo}" width="150px" /> 
                            <p class="white bold mt-3"> ${translate('PLEASE_VERIFY_YOUR_EMAIL_ADDRESS')}</p>
                            <p class="gray">${translate('PLEASE_VERIFY_YOUR_EMAIL_ADDRESS2')}</p>
                            <button class="button-primary mt-2" onclick="reloadAppNow();">${translate('UPDATE_IT')}</button>
                            <button class="button-void mt-4" onclick="logoutFromAccount();">${translate('LOGOUT')}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `);
    BSLight.ModalShow('#modal-verify-email');
    addPageToState("modal-verify-email");
}


function setCustomChannelId(){
    if($('#inputCustomChannelId').val()) {
        CHANNEL_ID = $('#inputCustomChannelId').val();
        $.ajax({
            url: URL_API+"/user/?f=settings_company&cid="+CHANNEL_ID, 
            method: "GET",
            dataType: "json",
            success: function(response) {
                if(response.status == 'success'){

                    // reload solo a commit avvenuto (callback della transazione)
                    db.transaction(function(tx) {
                        tx.executeSql('INSERT OR REPLACE INTO info (key, value) VALUES (?, ?)', ['channel_id', CHANNEL_ID]);
                    }, function(error) {
                        console.error("Errore durante il salvataggio channel id", error);
                    }, function() {
                        window.location.reload();
                    });

                }else{
                    window.plugins.toast.showShortBottom('Invalid Channel ID');
                }
            }
        });

    }else{
        window.plugins.toast.showShortBottom('No Channel ID inserted');
    }
}

function showChannelIdSelector(){
    $('body').append(`
        <div id="modal-channel-selector" class="modal fade">
            <div class="modal-dialog">
                <div class="modal-content" style="background-image: url('https://assets-global.website-files.com/6231ecc55204df314d4a187c/64fc5e39e2c33de39920789a_hero-glow.svg') !important; background-size:auto; background-position: -200px 400px;">
                    <div class="modal-body" id="modal-channel-selector-body" >
                         <div class="text-center pa-2" style="margin-top:30vh;">
                            <img src="https://assets-global.website-files.com/6231ecc55204df314d4a187c/651edb8fb981486b2066f759_dark.svg" width="150px" /> 
                            <input id="inputCustomChannelId" type="text" class="form-control mt-3" placeholder="Channel ID"/>
                            <button onclick="setCustomChannelId();" class="button-primary mt-1" id="buttonAccessWithChannelId" ><i class="ri-arrow-right-line"></i></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `);
    BSLight.ModalShow('#modal-channel-selector');
}

function updateUserOnDatabase(){
    // db.transaction(function(tx) {
    //     tx.executeSql('INSERT OR REPLACE INTO info (key, value) VALUES (?, ?)', ['user', JSON.stringify(userData)], function(tx, result) {
    //         console.log("Dati salvati con successo nella tabella info del database per l'utente");
    //     }, function(error) {
    //         console.error("Errore durante il salvataggio dei dati nella tabella info:", error);
    //     });
    // });
    try {
        db.transaction(function(tx) {
            tx.executeSql('INSERT OR REPLACE INTO info (key, value) VALUES (?, ?)', ['token', userToken], function(tx, result) {
                console.log("Dati salvati con successo nella tabella info del database per l'utente");
            }, function(error) {
                console.error("Errore durante il salvataggio dei dati nella tabella info:", error);
            });
        });
    } catch (e) {
        console.log(e);
    }
}

function initPusherToPreventMultiSession(){
    try {
        var channel = pusher.subscribe("notification_" + userToken);
            channel.bind("notification", function (data) {
                var text = JSON.parse(data);
                if (text.type == "session_ended") {
                    logoutFromAccount();
                }
        });
    }catch(error) {}
}

// Dopo il logout l'app riparte dalla home come al primo avvio. Con la shell
// remota (TY_WEB) l'URL corrente può essere un layer (/profile): si torna su
// '/' mantenendo i parametri dell'app (channel_id, app_scheme...), senza i
// quali partirebbe il selettore del canale
function reloadAppHome() {
    if (window.TY_WEB && typeof Nav !== 'undefined' && Nav.urlFor) {
        window.location.replace(Nav.urlFor('home'));
    } else {
        window.location.reload(true);
    }
}

function logoutFromAccount(){

    try {
        $.ajax({
            type: "DELETE",
            url: URL_API2 + "/sessions/authentication",
            success: function () {
                console.log("DELETE sessions/authentication");
            },
        });
    } catch (error) {

    }

    // il reload avviene SOLO nel callback di successo della transazione
    // (commit avvenuto): ricaricare prima del commit può annullare la
    // cancellazione (issue nota del plugin dopo location change)
    try {
        db.transaction(function(tx) {
            tx.executeSql('DELETE FROM info WHERE key = ?', ['token']);
        }, function(error) {
            console.error("Errore durante l'eliminazione della chiave 'token' dalla tabella info:", error);
            localStorage.clear();
            reloadAppHome();
        }, function() {
            console.log("Chiave 'token' eliminata con successo dalla tabella info");
            localStorage.clear();
            reloadAppHome();
        });
    } catch (e) {
        localStorage.clear();
        reloadAppHome();
    }
}

// function scanQrCodeChannelId(){
    
//     monaca.BarcodeScanner.scan(
//         function(result) {
//             // Verifica se l'utente ha annullato la scansione
//             if (!result.cancelled) {
//                 // console.log("Codice Scansionato: " + result.text);
//                 $('#inputCustomChannelId').val(result.data.text);
//                 $('#buttonAccessWithChannelId').trigger('click');
//             } else {
//                 // console.log("Scansione annullata");
//             }
//         },
//         function(error) {
//             console.error("Errore durante la scansione: " + error);
//         },
//         {
//            "oneShot" : true,
//             "timeoutPrompt" : {
//                 "show" : true,
//                 "timeout" : 5,
//                 "prompt" : "Not detected"
//             }
//         }
//     );


// }

function onSuccessBrowserTabOpened() {
    console.log("L'URL è stato aperto con successo nel browser custom tab.");
}
function onErrorBrowserTabOpened(error) {
    console.error("Si è verificato un errore durante l'apertura dell'URL nel browser custom tab:", error);
}


app.initialize();
